import { MAX_PASSWORD_LENGTH, MIN_PASSWORD_LENGTH } from '@/constants/Common'
import * as Yup from 'yup'

export const createSignUpStep2ValidationSchema = (t: any) => {
  return Yup.object().shape({
    password: Yup.string()
      .required(t('constant.passRequired'))
      .min(MIN_PASSWORD_LENGTH, t('constant.passMinLength'))
      .matches(/^\S*$/, t('constant.passNoWhiteSpace'))
      .matches(/^(?=.*[a-zA-Z])(?=.*[0-9])(?=.{6,})/, t('constant.passStrength'))
      .max(MAX_PASSWORD_LENGTH, t('constant.passMaxLength')),
    confirmPassword: Yup.string()
      .required(t('constant.passRequired'))
      .min(MIN_PASSWORD_LENGTH, t('constant.passMinLength'))
      .max(MAX_PASSWORD_LENGTH, t('constant.passMaxLength'))
      .oneOf([Yup.ref('password'), ''], t('constant.passMatch')),
  })
}
